import React, { useEffect, useState } from "react";

import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { getCurrentUserParams, updateAccountNotification } from "@backend/AccountRequests";
import { setUserCredentials } from "@reducer/index";

import "./NotificationModal.scss";

export function NotificationModal({ ...props }) {
    const dispatch = useDispatch();
    const [t] = useTranslation();

    const [checkbox, setCheckbox] = useState(false);

    //#region Effect Hooks
    useEffect(() => {
        if (checkbox) {
            updateNotification();
        }
    }, [checkbox]);

    //#endregion

    //#region Functions
    async function updateNotification() {
        const data = await updateAccountNotification(!checkbox);

        if (!data.success) {
            throw new Error("Failed to update notification preference");
        }

        getCurrentUser();
    }

    async function getCurrentUser() {
        const data = await getCurrentUserParams();
        if (data.success) {
            dispatch(setUserCredentials(data.data));
            props.onHide();
        }
    }

    //#endregion

    return (
        <Modal {...props} centered dialogClassName="notification-modal">
            <Modal.Header className="notification-modal-header" closeButton>
                <div className="title">{t("NotificationTitle")}</div>
            </Modal.Header>
            <Modal.Body className="notification-modal-content">
                <div className="subtitle">{t("NotificationText")}</div>
                <div className="checbox-wrapper">
                    <div className="is-checkbox pointer" onClick={() => setCheckbox(!checkbox)}>
                        {checkbox ? "check_box" : "check_box_outline_blank"}
                    </div>
                    <div className="text">{t("DontShowAgain")} </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
